import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { CONTACT, ROUTES } from "../../config/site";

const DeskStrip = styled.aside`
  width: 100%;
  background-color: var(--brand-blue);
  color: var(--paper);
  padding-block: 20px;
  padding-inline: var(--margin);

  .strip-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
  }

  .strip-copy {
    display: flex;
    align-items: baseline;
    gap: 14px;
    flex-wrap: wrap;
  }

  .strip-title {
    font-family: 'Oswald', sans-serif;
    font-size: var(--step-lead);
    font-weight: 700;
    text-transform: uppercase;
    color: var(--paper);
  }

  .strip-sub {
    font-family: 'Barlow', sans-serif;
    font-size: var(--step-body);
    color: var(--paper);
  }

  .strip-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
`;

const ActionLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 18px;
  background-color: var(--chapter-dark);
  color: var(--paper);
  font-family: 'Oswald', sans-serif;
  font-size: var(--step-body);
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
  transition: background-color 0.18s var(--ease-out), transform 0.18s var(--ease-out);

  &:hover,
  &:focus {
    background-color: var(--brand-green-dark);
    color: var(--paper);
    transform: translateY(-2px);
  }
`;

const QuoteLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 18px;
  background-color: var(--paper);
  color: var(--chapter-dark);
  font-family: 'Oswald', sans-serif;
  font-size: var(--step-body);
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
  transition: background-color 0.18s var(--ease-out), transform 0.18s var(--ease-out);

  &:hover,
  &:focus {
    background-color: var(--surface);
    color: var(--chapter-dark);
    transform: translateY(-2px);
  }
`;

const FloatingContact = () => {
  const whatsappLink = `https://wa.me/${CONTACT.phone.replace("+", "")}`;

  return (
    <DeskStrip aria-label="Direct Dubai trading desk dispatch">
      <div className="strip-inner">
        <div className="strip-copy">
          <span className="strip-title">24-Hour UAE Scrap Dispatch</span>
          <span className="strip-sub">
            Same-day weighbridge settlement in AED or USD from Port Saeed, Deira.
          </span>
        </div>
        <div className="strip-actions">
          <ActionLink href={whatsappLink} target="_blank" rel="noopener noreferrer">
            WhatsApp Desk
          </ActionLink>
          <ActionLink href={`tel:${CONTACT.phone}`}>
            Call {CONTACT.phone}
          </ActionLink>
          <QuoteLink to={ROUTES.contact.path}>
            Book Yard Pickup
          </QuoteLink>
        </div>
      </div>
    </DeskStrip>
  );
};

export default FloatingContact;
